module.exports = __webpack_public_path__ + "media/images/flags/1x1/lby-5593aa3a2e568bda1ebe36f3ecc4f766.svg";